import React from "react";
import { ReactSVG } from "react-svg";
import arrow_back from "../assets/svgs/arrow_back.svg";
import { useNavigate, useLocation } from "react-router-dom";
import ReferralList from "../pages/ReferralList";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const topupPath = location.pathname === "/topup";
  const registerPath = location.pathname === "/selfregister";
  const orderPath = location.pathname === "/order";
  const orderDetailPath = location.pathname === "/package-detail";
  const planPath = location.pathname === "/plan";
  const historyPath = location.pathname === "/history";
  const dealerPath = location.pathname === "/dealer";
  const registerDealer = location.pathname === "/dealer-register";
  const registeredPath = location.pathname === "/registered-customers";
  const MNPPath = location.pathname === "/mnp";
  const MNPRegPath = location.pathname === "/mnp-register";
  const MNPRegFormPath = location.pathname === "/mnp-register-form";
  const CashbackPath = location.pathname === "/cashback-history";
  const MoreDetail = location.pathname === "/more-detail";
  const ExtendValidityPath = location.pathname === "/extend-validity";
  const AddOnPlanPath = location.pathname === "/add-on-plan";
  const referralListPath = location.pathname === "/referral-list";

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/home");
    }
  };

  return (
    <div className="w-full grid grid-cols-3 bg-white py-6 px-2 border-b-[1px] border-black/10">
      <div onClick={handleGoBack} className="flex gap-1 items-center">
        <ReactSVG src={arrow_back} />
        <p className="text-[17px] text-primary whitespace-nowrap">
          Back
        </p>
      </div>
      <h3 className="font-semibold text-[17px] text-center absolute left-1/2 -translate-x-1/2 whitespace-nowrap overflow-visible">
        {topupPath
          ? "Topup"
          : registerPath
            ? "Self Registration"
            : orderPath
              ? "Food Order"
              : orderDetailPath
                ? "Package Detail"
                : historyPath
                  ? "History"
                  : dealerPath
                    ? "As a Smart Partner"
                    : registerDealer
                      ? "Sim Card Registration"
                      : MoreDetail
                        ? "Manage Data"
                        : MNPPath
                          ? "MNP"
                          : MNPRegPath
                            ? "MNP"
                            : MNPRegFormPath
                              ? "MNP"
                              : CashbackPath
                                ? "Cashback History"
                                : ExtendValidityPath
                                  ? "Extend Validity"
                                  : AddOnPlanPath
                                    ? "Add-on Plan"
                                    : registeredPath
                                      ? "Direct Referral(Reg)"
                                      : referralListPath
                                        ? "Referral List"
                                        : "New Plan"}
      </h3>
    </div>
  );
};

export default Header;
